import React from "react";
import "./TargetBelajar.css";
import modelTarget from "../../assets/target_pembelajaran/target belajar_bintara.webp";
import checkIcon from "../../assets/sec_benefit_sc/icon_check.webp";

const TargetBelajarBintara = () => {
  return (
    <React.Fragment>
      <div className="container-target-belajar">
        <div className="box-target-belajar">
          <div className="text-target-brlajar">
            <h1 className="title-target-belajar">Target Pembelajaran</h1>
            <span className="list-target-belajar">
              <img
                src={checkIcon}
                alt="Bimbingan Masuk Sekolah Kedinasan"
                className="icon-check"
              />
              Memaksimalkan potensi belajar siswa berdasarkan mapping minat
              bakat siswa.
            </span>
            <span className="list-target-belajar">
              <img
                src={checkIcon}
                alt="Bimbingan Masuk Sekolah Kedinasan"
                className="icon-check"
              />
              Penguasaan materi akademik maupun psikotes dengan drilling soal
              dan pembahasan setiap hari.
            </span>
            <span className="list-target-belajar">
              <img
                src={checkIcon}
                alt="Bimbingan Masuk Sekolah Kedinasan"
                className="icon-check"
              />
              Peningkatan progress performa fisik siswa sesuai target maksimal.
            </span>
            <span className="list-target-belajar">
              <img
                src={checkIcon}
                alt="Bimbingan Masuk Sekolah Kedinasan"
                className="icon-check"
              />
              Siswa memahami teknis seleksi maupun penilaian supaya lebih bisa
              meningkatkan skill individu masing-masing.
            </span>
            <span className="list-target-belajar">
              <img
                src={checkIcon}
                alt="Bimbingan Masuk Sekolah Kedinasan"
                className="icon-check"
              />
              Siswa lebih percaya diri dan mudah melewati setiap tahapan
              seleksi.
            </span>
            <span className="list-target-belajar">
              <img
                src={checkIcon}
                alt="Bimbingan Masuk Sekolah Kedinasan"
                className="icon-check"
              />
              Siswa lolos terpilih dan meraih cita-cita yang di impikan.
            </span>
          </div>
          <img
            src={modelTarget}
            alt="Bimbingan Masuk Sekolah Kedinasan"
            className="model-target-belajar"
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default TargetBelajarBintara;
